import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { MovimientoTramite } from "./movimiento-tramite.models";

export interface MovimientoTramiteState extends EntityState<MovimientoTramite> {
  loaded?: boolean
  isLoading: boolean;
  error?: Error | null;
}

export const movimientoTramiteAdapter: EntityAdapter<MovimientoTramite> =
  createEntityAdapter<MovimientoTramite>({
    selectId: (model) => model.id,
    sortComparer: (a: MovimientoTramite, b: MovimientoTramite): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export const movimientoTramiteInitialState: MovimientoTramiteState =
  movimientoTramiteAdapter.getInitialState({
    isLoading: false,
    error: null
  });
